import Codes from "./AsxETFs";

export class AsxEtfUtil {
    public static isEtf(code: string): boolean {
        return Codes.includes(code);
    }
}
